import { useState } from "react";
import { Button } from "@/components/ui/button";
import logo from "@/assets/logo.png";

function NavBar() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <nav className="sticky top-0 z-50 bg-white shadow-sm border-b border-[#f9e2e8]/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative flex items-center h-16">
          {/* Logo (Left) */}
          <div className="flex items-center w-auto md:w-[220px]">
            <a href="/" className="flex items-center">
              <img src={logo} alt="Logo" className="h-10 sm:h-12 w-auto" />
            </a>
          </div>

          {/* Navigation (Center on Desktop) */}
          <div className="hidden md:flex flex-1 items-center justify-center gap-8">
            <a
              href="/"
              className="text-foreground hover:text-[#D2138C] transition-colors">
              Home
            </a>

            <a
              href="/properties"
              className="text-foreground hover:text-[#D2138C] transition-colors">
              Properties
            </a>

            <a
              href="https://nurseassist247.com.au/our-values/"
              className="text-foreground hover:text-[#D2138C] transition-colors">
              About
            </a>

            <a
              href="/contact"
              className="text-foreground hover:text-[#D2138C] transition-colors">
              Contact
            </a>
          </div>

          {/* Right side: CTA + Burger */}
          <div className="ml-auto flex items-center gap-2 sm:gap-3 md:w-[220px] md:justify-end">
            {/* CTA */}
            <a href="/#list-your-property">
              <Button
                variant="default"
                className="bg-[#D2138C] hover:bg-pink-700 rounded-full text-white h-9 px-3 text-sm sm:h-10 sm:px-4 md:h-11 md:px-6 md:text-base whitespace-nowrap">
                List your property
              </Button>
            </a>

            {/* Burger button (Mobile only) */}
            <button
              type="button"
              className="md:hidden h-9 w-9 sm:h-10 sm:w-10 rounded-full border border-gray-200 flex items-center justify-center"
              onClick={() => setMobileOpen((v) => !v)}
              aria-label={mobileOpen ? "Close menu" : "Open menu"}>
              {mobileOpen ? (
                <span className="text-xl leading-none">✕</span>
              ) : (
                <span className="text-xl leading-none">≡</span>
              )}
            </button>
          </div>

          {/* Optional click-outside close (keeps background invisible) */}
          {mobileOpen && (
            <button
              type="button"
              className="md:hidden fixed inset-0 z-40 cursor-default"
              onClick={() => setMobileOpen(false)}
              aria-label="Close menu overlay"
            />
          )}

          {/* Mobile Menu (Card only, no background overlay) */}
          {mobileOpen && (
            <div className="md:hidden absolute right-0 top-full mt-2 z-50">
              <div className="bg-white rounded-2xl border border-gray-200 shadow-lg overflow-hidden w-[240px] sm:w-[280px]">
                <a
                  href="/"
                  className="block px-5 py-4 text-gray-800 hover:bg-gray-50"
                  onClick={() => setMobileOpen(false)}>
                  Home
                </a>
                <a
                  href="/properties"
                  className="block px-5 py-4 text-gray-800 hover:bg-gray-50"
                  onClick={() => setMobileOpen(false)}>
                  Properties
                </a>
                <a
                  href="https://nurseassist247.com.au/our-values/"
                  className="block px-5 py-4 text-gray-800 hover:bg-gray-50"
                  onClick={() => setMobileOpen(false)}>
                  About
                </a>
                <a
                  href="/contact"
                  className="block px-5 py-4 text-gray-800 hover:bg-gray-50"
                  onClick={() => setMobileOpen(false)}>
                  Contact
                </a>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}

export default NavBar;
